import {CursorBasedPaginationRequest, CursorBasedPaginationResponse} from 'api/common';

export interface SprintModel {
    id?: string;
    title: string;
    startData: string;
    endData: string;
    sprintStatus: SprintStatus;
    boardId: string;
    isPinned: boolean;
    isDefault: boolean;
    details?: string;
}

export interface SprintCreateUpdateRequestModel extends Omit<SprintModel, 'sprintStatus' | 'boardId'> {
    boardSlug: string;
}

export interface SprintResponseModel extends SprintModel {
    incompleteItemCount?: number;
}

export interface SprintByBoardIdRequest extends CursorBasedPaginationRequest {
    boardId: string;
    search?: string;
}

export interface SprintPaginationResponse {
    allSprints: CursorBasedPaginationResponse<SprintResponseModel>;
}

export const sprintCreateDefaultValues: SprintCreateUpdateRequestModel = {
    boardSlug: '',
    title: '',
    startData: '',
    endData: '',
    isPinned: false,
    isDefault: false,
    details: '',
};
export enum SprintStatus {
    Past = 'PAST',
    Future = 'FUTURE',
    Current = 'CURRENT',
    Closed = 'CLOSED',
    All = 'ALL',
}
